module.exports = __webpack_public_path__ + "static/media/S (4).74754c28.jpg";